import type { R2BReferralBrandEntity } from "../../entity_types/r2bReferralBrand";

export const r2b_referral_2: R2BReferralBrandEntity = {
  token: "r2b_referral_2",
  type: "r2bReferralBrand",
  name: "Rustic Ridge Co.",
  email: "amani.denesik@example.com",
  website: "trendify.net",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
